import Auth from '@aws-amplify/auth'

import config from '../../config'

const AwsConfig = {
  Auth: {
    authenticationFlowType: 'USER_SRP_AUTH',
    mandatorySignIn: true,
    ...config.cognito,
  },
  API: {
    endpoints: [
      {
        name: 'default',
        custom_header: async () => {
          try {
            return {
              Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`,
            }
          } catch (err) {
            console.error('Token error', err)
          }
        },
        ...config.api,
      },
    ],
  },
}

export default AwsConfig
